module.exports = __webpack_public_path__ + "static/img/selected2.17aafd01.png";